import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material';
import { SearchParams, SearchParamsDraw } from '../shared/misc-classes';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-draw-so-nos',
  templateUrl: './draw-so-nos.component.html',
  styleUrls: ['./draw-so-nos.component.css']
})
export class DrawSoNosComponent implements OnInit {
  @Input() searchOptionsDraw:SearchParamsDraw;

  constructor() { }

  ngOnInit() {

  }


  extractSOsPasted(){
    var _tokens:Array<string> = this.searchOptionsDraw.pastedSONosStr.split(/,|-|\t|\r|\n| /);

    this.searchOptionsDraw.extractedSONumbers = _tokens.filter((_token:string) => { return _token.trim() != ""; });

    this.searchOptionsDraw.soNos.splice(0,this.searchOptionsDraw.soNos.length,...this.searchOptionsDraw.extractedSONumbers)
    //this.serialNos = this.extractedSerialNumbers.slice(0);
  }

  extractSOsFromTo(){
    this.searchOptionsDraw.soNos.length = 0;
    this.searchOptionsDraw.soExtractMessage = "";
    if(this.isRangeSONumbersValid() == true){
      var _rngSerials:Array<string> = this.getRangeSONos();
      if(_rngSerials != null){
        this.searchOptionsDraw.extractedSONumbers = _rngSerials.filter((_token:string) => { return _token.trim() != ""; });
        this.searchOptionsDraw.soNos.push(..._rngSerials);
      }
    }
  }
  getRangeSONos():Array<string>{
    var _fromSONo:number = parseInt((this.searchOptionsDraw.fromSONo.toLowerCase()),10);
    var _toSONo:number = parseInt((this.searchOptionsDraw.toSONo.toLowerCase()),10);
    console.log(_fromSONo,_toSONo)
    if(_fromSONo == NaN || _toSONo == NaN){
      this.searchOptionsDraw.soExtractMessage = "SO No is NOT VALID";
      return null;
    }
    if(_fromSONo > _toSONo){
      this.searchOptionsDraw.soExtractMessage = "From SO Cannot be more than To SO.";
      return null;
    }
    if(_toSONo == _fromSONo){
      this.searchOptionsDraw.soExtractMessage = "From SO Cannot be equal to To SO.";
      return null;
    }
    if(_toSONo - _fromSONo > 5000){
      this.searchOptionsDraw.soExtractMessage = "You cannot view more than 5000 SO numbers at a glance.";
      return null;
    }

    var _retVal:Array<string> = [];
    for(var i = _fromSONo;i <= _toSONo; i++){
      //remove the leading one added earlier    
      _retVal.push((i + ''));
    }
    return _retVal;
  }
  isRangeSONumbersValid():boolean{
    if(this.searchOptionsDraw.fromSONo.trim() == ""  || this.searchOptionsDraw.toSONo.trim() == ""){
      this.searchOptionsDraw.soExtractMessage = "SO Nos CANNOT be empty";
      return false;
    }
    if(isNaN(parseInt(this.searchOptionsDraw.fromSONo))  || 
    isNaN(parseInt(this.searchOptionsDraw.toSONo))){
      this.searchOptionsDraw.soExtractMessage = "SO No SHOULD be number";
      return false;
    }
    return true;
  }

  removeSNo(_soNo:string){
    while(this.searchOptionsDraw.soNos.indexOf(_soNo) >= 0){
      this.searchOptionsDraw.soNos.splice(this.searchOptionsDraw.soNos.indexOf(_soNo), 1);
    }
  }

  getSOCountMessage():string{
    if(this.searchOptionsDraw.extractedSONumbers.length == 0){
      return "No SO numbers extracted.";
    }
    else if(this.searchOptionsDraw.extractedSONumbers.length == this.searchOptionsDraw.soNos.length){
      return "Showing " + this.searchOptionsDraw.extractedSONumbers.length + " SO numbers extracted."
    }
    else{
      return "Selected " + this.searchOptionsDraw.soNos.length + " of " + this.searchOptionsDraw.extractedSONumbers.length + " extracted.";
    }
  }

  optionSelected(){
    this.searchOptionsDraw.extractedSONumbers.length = 0;
    this.searchOptionsDraw.soNos.length = 0;
  }

  onFileChange(evt: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});

      /* grab first sheet */
      var _tmpSOs:Array<string> = [];
      this.searchOptionsDraw.extractedSONumbers.length = 0;
      this.searchOptionsDraw.soNos.length = 0;
      for(var i = 0; i < wb.SheetNames.length; i++){
        const wsname: string = wb.SheetNames[i];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];  
        
        var _jsonArr:Array<any> = XLSX.utils.sheet_to_json(ws, {header: 1});

        for(var j = 0;j < _jsonArr.length; j++){
          if(_jsonArr[j].length > 0){
            for(var k = 0;k < _jsonArr[j].length;k++){
              if(_jsonArr[j][k] && typeof _jsonArr[j][k] == 'number'){
                _tmpSOs.push(_jsonArr[j][k]);
              }
            }
          }
        }
      }

      this.searchOptionsDraw.extractedSONumbers = _tmpSOs.filter((_token:string) => { return _token.trim() != ""; });
      this.searchOptionsDraw.soNos.push(..._tmpSOs);
      
      /* save data */
      //this.data = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));
    };
    reader.readAsBinaryString(target.files[0]);
  }
}